import { frontendURL } from '../../../helper/URLHelper';
import { FEATURE_FLAGS } from '../../../featureFlags';

const N8nIndex = () => import('./N8nDashboard.vue');
const WorkflowEditor = () => import('./WorkflowEditor.vue');

const commonMeta = {
  featureFlag: FEATURE_FLAGS.CRM,
  permissions: ['administrator', 'agent', 'custom_role'],
};

export const routes = [
  {
    path: frontendURL('accounts/:accountId/n8n'),
    name: 'n8n_dashboard',
    meta: commonMeta,
    component: N8nIndex,
  },
  {
    path: frontendURL('accounts/:accountId/n8n/workflows'),
    name: 'n8n_workflows',
    meta: commonMeta,
    component: N8nIndex,
  },
  {
    path: frontendURL('accounts/:accountId/n8n/:workflowId/edit'),
    name: 'n8n_workflow_editor',
    meta: commonMeta,
    component: WorkflowEditor,
  },
];
